import React from "react";
import {GenericLayout} from "../GenericLayout";
import {ContentNavBar} from "./ContentNavBar";

export const ContentLayout = ({children}: { children?: React.ReactNode | React.ReactNode[] }) => {
    return <GenericLayout
        navbar={<ContentNavBar/>}
    >{children}</GenericLayout>
}